export default __webpack_public_path__ + "./fonts/advisor.f7f7b34c.svg";